import { ContentProps } from '../models/TopLevelTemplateComponentProps';
import sanitizeHTML from './sanitizeHTML';

export function textContentToHtml(
  content: ContentProps | ([ContentProps, ContentProps[]] | ContentProps)[],
): string {
  if (Array.isArray(content)) {
    const items = content
      .map((item) => {
        if (Array.isArray(item)) {
          const [parent, children] = item as [ContentProps, ContentProps[]];
          const childHtml = children
            .map((child) => `<li>${sanitizeHTML(child.content)}</li>`)
            .join('');
          return `<li>${sanitizeHTML(parent.content)}<ul>${childHtml}</ul></li>`;
        }
        const flat = item as ContentProps;
        return `<li>${sanitizeHTML(flat.content)}</li>`;
      })
      .join('');
    return `<ul>${items}</ul>`;
  }
  return `<p>${sanitizeHTML(content.content)}</p>`;
}
